import React, { Component } from "react";
import 'react-treeview/react-treeview.css';
import '../../assets/css/ts-report.css';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions/streamListActions';

import {Grid,
  Row,
  Col,
  Panel
} from "react-bootstrap";

import TreeView from 'react-treeview';

class StreamTSDetails extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      selectedContainer: {},
      tsReport: {},
    }
    this.getPMTNodes = this.getPMTNodes.bind(this);
    this.downloadServiceReportInput = this.downloadServiceReportInput.bind(this);
    this.downloadServiceReportOutput = this.downloadServiceReportOutput.bind(this);
    this.downloadTSReportInput = this.downloadTSReportInput.bind(this);
    this.downloadTSReportOutput = this.downloadTSReportOutput.bind(this);
  }

  getPMTNodes() {
    return this.props.tsReport.output.tables.map((pmtnode, i) => {
      if(pmtnode.name.toLowerCase() === "pmt")
      return (
        <div className="info">{pmtnode.name} Table, PID {pmtnode.pid}</div>
      );
    })
  }

  downloadServiceReportInput() {
    if(this.props.selectedContainer && this.props.selectedContainer.Id != 0) {
      const { downloadReport } = this.props.actions;
      downloadReport(this.props.selectedContainer.Id, "analysis", this.props.selectedContainer.sourceIP, this.props.selectedContainer.sourcePort, window.location.origin);
    }
  }

  downloadServiceReportOutput() {
    if(this.props.selectedContainer && this.props.selectedContainer.Id != 0) {
      const { downloadReport } = this.props.actions;
      downloadReport(this.props.selectedContainer.Id, "analysis", this.props.selectedContainer.destIP, this.props.selectedContainer.destPort, window.location.origin);
    }
  }

  downloadTSReportInput() {
    if(this.props.selectedContainer && this.props.selectedContainer.Id != 0) {
      const { downloadReport } = this.props.actions;
      downloadReport(this.props.selectedContainer.Id, "tstables", this.props.selectedContainer.sourceIP, this.props.selectedContainer.sourcePort, window.location.origin);
    }
  }

  downloadTSReportOutput() {
    if(this.props.selectedContainer && this.props.selectedContainer.Id != 0) {
      const { downloadReport } = this.props.actions;
      downloadReport(this.props.selectedContainer.Id, "tstables", this.props.selectedContainer.destIP, this.props.selectedContainer.destPort, window.location.origin);
    }
  }

  render() {
    const labelTSIDInput = <span className="node">Input Transport Stream ID {this.props.tsReport.input.tsID}</span>;
    const actionServiceReportInput = <button className="btn btn-primary" onClick={this.downloadServiceReportInput}>Download SERVICES ANALYSIS REPORT</button>;
    const actionTSTableReportInput = <button className="btn btn-primary" onClick={this.downloadTSReportInput}>Download TS TABLES REPORT</button>;
    const labelTSIDOutput = <span className="node">Output Transport Stream ID {this.props.tsReport.output.tsID}</span>;
    const actionServiceReportOutput = <button className="btn btn-primary" onClick={this.downloadServiceReportOutput}>Download SERVICES ANALYSIS REPORT</button>;
    const actionTSTableReportOutput = <button className="btn btn-primary" onClick={this.downloadTSReportOutput}>Download TS TABLES REPORT</button>;

    return (
      this.props.enableTSStats && 
      (this.props.tsReport.input.tables.length > 0 || this.props.tsReport.input.programs.length > 0 || this.props.tsReport.output.tables.length > 0 || this.props.tsReport.output.programs.length > 0) && 
      <div className="content">
        <Grid fluid>
          <Panel bsStyle="primary">
            <Panel.Heading>
              <Panel.Title componentClass="h3">MPEG TS Details</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <Row>
                <Col
                  md={6}
                  style={{ paddingLeft: 3 + "px", paddingRight: 3 + "px" }}
                >
                  {(this.props.tsReport.input.tables.length > 0 || this.props.tsReport.input.programs.length > 0) &&
                  <div className="report-tree">
                    {actionServiceReportInput}<br />
                    {actionTSTableReportInput}
                    <TreeView key={'root'} nodeLabel={labelTSIDInput} defaultCollapsed={false}>
                      {this.props.tsReport.input.tables.map((node, i) => {
                        const label = <span className="node">{node.name} Table, PID {node.pid}</span>;
                        if(node.name.toLowerCase() == "pat")
                        return (
                          <TreeView key={'table_' + node.name.toLowerCase()} nodeLabel={label} defaultCollapsed={false}>
                              {this.props.tsReport.input.programs.map((node, i) => {
                              const label = <span className="node">Program ID {node.program}{node.program_name && ', '}{node.program_name}</span>;
                              const labels = <span className="node">PMT Table, PID {node.pmtpid}</span>;
                              let networkNameAndProvider = [];
                              if(this.props.tsReport.input.network_name) {
                                networkNameAndProvider.push('Network Name: ' + this.props.tsReport.input.network_name);
                              }
                              if(node.provider) {
                                networkNameAndProvider.push('Provider: ' + node.provider);
                              }
                              return (
                                <TreeView key={ node.pmtpid } nodeLabel={labels} defaultCollapsed={false}>
                                  <TreeView key={'program_' + node.pmtpid} nodeLabel={label} defaultCollapsed={false}>
                                    <div className="info">Video Type: {node.video_type}, Video PID {node.video_pid}</div>
                                    <div className="info">Audio Type: {node.audio_type}, Audio PID {node.audio_pid}</div>
                                    <div className="info">{networkNameAndProvider.join(', ')}</div>
                                  </TreeView>
                                </TreeView>
                              );
                            })}
                          </TreeView>
                        );
                        if(node.name.toLowerCase() !== "pmt" && node.name.toLowerCase() !== "pat")
                        return (
                          <div className="info">{label}</div>
                        );
                      })}
                    </TreeView>
                  </div>}
                </Col>
                <Col
                  md={6}
                  style={{ paddingLeft: 3 + "px", paddingRight: 3 + "px" }}
                >
                  {(this.props.tsReport.output.tables.length > 0 || this.props.tsReport.output.programs.length > 0) &&
                  <div className="report-tree">
                    {actionServiceReportOutput}<br />
                    {actionTSTableReportOutput}
                    <TreeView key={'root'} nodeLabel={labelTSIDOutput} defaultCollapsed={false}>
                      {this.props.tsReport.output.tables.map((node, i) => {
                        const label = <span className="node">{node.name} Table, PID {node.pid}</span>;
                        if(node.name.toLowerCase() == "pat")
                        return (
                          <TreeView key={'table_' + node.name.toLowerCase()} nodeLabel={label} defaultCollapsed={false}>
                              {this.props.tsReport.output.programs.map((node, i) => {
                              const label = <span className="node">Program ID {node.program}{node.program_name && ', '}{node.program_name}</span>;
                              const labels = <span className="node">PMT Table, PID {node.pmtpid}</span>;
                              let networkNameAndProvider = [];
                              if(this.props.tsReport.output.network_name) {
                                networkNameAndProvider.push('Network Name: ' + this.props.tsReport.output.network_name);
                              }
                              if(node.provider) {
                                networkNameAndProvider.push('Provider: ' + node.provider);
                              }
                              return (
                                <TreeView key={ node.pmtpid } nodeLabel={labels} defaultCollapsed={false}>
                                  <TreeView key={'program_' + node.pmtpid} nodeLabel={label} defaultCollapsed={false}>
                                    <div className="info">Video Type: {node.video_type}, Video PID {node.video_pid}</div>
                                    <div className="info">Audio Type: {node.audio_type}, Audio PID {node.audio_pid}</div>
                                    <div className="info">{networkNameAndProvider.join(', ')}</div>
                                  </TreeView>
                                </TreeView>
                              );
                            })}
                          </TreeView>
                        );
                        if(node.name.toLowerCase() !== "pmt" && node.name.toLowerCase() !== "pat")
                        return (
                          <div className="info">{label}</div>
                        );
                      })}
                    </TreeView>
                  </div>}
                </Col>
              </Row>
            </Panel.Body>
          </Panel>
        </Grid>
      </div>
    );
  }
}

StreamTSDetails.propTypes = {
  actions: PropTypes.object.isRequired,
};

function getCurrentStream(state){
  if(state.srtStats.containerId !== undefined)
    return state.streamList.containers.find( c => c.Id === state.srtStats.containerId);
  else
    return state.streamList.containers[0];
}

function mapStateToProps(state) {
  return {
    tsReport: state.tsReport,
    selectedContainer: getCurrentStream(state),
    enableTSStats: state.sysConfig.about.enableTSStats
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StreamTSDetails);
